<template>
  <div>
    <!-- 顶部一级菜单 -->
    <div v-if="!islogin" class="t_top_nav">
      <div class="t_top_logo">
        <img src="./assets/img/91logo.png" alt="91fen">
        <span class="t_top_comp">{{logincompname}}</span>
      </div>
      <nav class="t_nav_headlist">
        <!-- 一级导航 -->
        <div class="t_nav_headitem" v-for="(item,index) in navonelist.data" :key="index">
          <router-link v-if="item.meta.show && item.meta.role.includes(loginrole)" :to="item.path">{{ item.meta.title }}</router-link>
        </div>
      </nav>
      <div class="t_myinfobox">
        <div class="t_enter_shop" @click="enterShop">进入商城</div>
        <div class="t_workbench">客服工作台</div>
        <div class="t_icon_bell" title="通知">
          <el-badge :value="5">
            <el-icon :size="18"><BellFilled /></el-icon>
          </el-badge>
        </div>
        <div class="t_my_msg">
          <!-- <img :src="loginavatar" class="t_headimg"> -->
          <el-dropdown @command="setmine" class="example-showcase">
            <span class="el-dropdown-link">
              <span class="t_avatar">{{ (loginusername || 'U').charAt(0) }}</span>
              <span class="t_username">{{loginusername}}</span>
              <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="mine">账号信息</el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div :class="{ t_pagebody: !islogin }">
      <!-- 左侧二级目录 -->
      <div v-if="!islogin" class="t_navslidebox">
        <div class="t_sidebar_title">当前模块</div>
        <!-- 二级导航 -->
        <div class="t_nav_itemlist">
          <template v-for="(item,index) in navitemlist.data" :key="index">
            <!-- 判断是否有权限，当前账号的权限是 0，判断是否在[0,1]中有，有则返回 true -->
            <router-link v-if="item.meta.show && item.meta.role.includes(loginrole)" :to="item.path" class="t_nav_item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M8 12h8"/></svg>
              <span>{{ item.meta.title }}</span>
            </router-link>
          </template>
        </div>
      </div>

      <!-- 主内容区 -->
      <div :class="{ t_content_box: !islogin }">
        <div :class="{ t_con_content: !islogin }">
          <router-view />
        </div>
        <div v-if="!islogin" class="t_footer">
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <img style="display: inline;width: 14px;vertical-align: -2px;" src="./assets/img/gh.png" alt="">
            鲁ICP备2021006226号-3
          </a>
        </div>
      </div>
  </div>

  </div>
</template>
<script  setup>
import { ArrowDown } from '@element-plus/icons-vue'
import { ref, reactive, provide, onBeforeMount, onMounted, watch, inject,getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { gettoken,getmy,newoutlogin,newauth,newgetshoptoken } from '@/assets/js/common.js'
import { ElMessage } from 'element-plus'
import { useStore } from './store'
import { storeToRefs } from 'pinia'


//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()

const { proxy } = getCurrentInstance();
onMounted(()=>{
  
});


//动态获取接口地址
const _url2 = inject('_url2')
const _url = inject('_url')
//是否是登录页面
const islogin = ref(false)
//当前top
const nowTop = ref(null)
//当前二级菜单组件
const nowslidecomp = ref(null)

//获取连接中的参数
const GetRequest = () => {
  var url = location.search;   //获取url中"?"符后的字串   
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {

    var str = url.substr(1);

    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);

      //解决中文参数问题
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

//登录code
// const auth_code = ref('')

//进入商城：不限制账号角色，是否可进由后端校验
const enterShop = ()=>{
  newgetshoptoken().then((response)=>{
    const body = response && response.data ? response.data : {}
    if(!body.msg || body.msg.code !== 0) return
    const data = body.data || {}
    if(!data.domain || !data.account_token) return
    window.open('https://'+data.domain+'/admin/account/login?token='+data.account_token,'_blank')
  })
}



const loginavatar = ref('')
const loginusername = ref('')
const logincompname = ref('')
const loginrole = ref(null)


//一级菜单
const navonelist = reactive({
  data:[]
})

//二级菜单
const navitemlist = reactive({
  data:[]
})

//接口异常也要完成本地退出
const logout = async () => {
  try {
    await newoutlogin()
  } catch (error) {
    // 服务端退出失败不阻断本地退出。
  }
  $cookies.set("fanstoken", '')
  await router.push({ path: '/login' })
  ElMessage({
    message: '退出成功',
    type: 'success',
  })
}

//监听当前路由
watch(() => router.currentRoute.value.path, (newValue, oldValue) => {

  //H5 页面不套后台壳、不做后台鉴权（用真实地址判断：watch 首次触发时 newValue 还是 '/'）
  if (window.location.pathname.indexOf('/h5/') == 0 || newValue.indexOf('/h5/') == 0) {
    islogin.value = true
    return
  }

  //获取所有路由
  var allroute = proxy.$router.options.routes
  var url = newValue
  var nownav = '/'+url.split('/')[1]
  //将/和/login排除掉
  navonelist.data =  allroute.slice(2)
  console.log('获取所有路由')
  console.log(allroute)


  //获取二级
  for(var x = 0;x<allroute.length;x++){
    if(allroute[x].path==nownav){
      if(allroute[x].children){
        navitemlist.data = allroute[x].children
      }
    }
  }
  //添加二级图片地址
  if(navitemlist.data.length!=0){
    for(var y = 0;y<navitemlist.data.length;y++){
      var img =  navitemlist.data[y].meta.img
      if(navitemlist.data[y].meta.img!=''){
        navitemlist.data[y].meta.imgurl = require('./assets/img/'+img)
      }
    }
  }


  console.log('oldValue:'+oldValue)
  console.log('newValue:'+newValue)


        
 
  //判断是否有token
  // if (!$cookies.get("fanstoken")) {
  //   //判断是否扫码登录
  //   if (GetRequest().code) {
  //     //指定路由才执行一次
  //     if(oldValue=='/'&&newValue=='/navhome/home'){
 
  //       //获取token
  //       gettoken(_url2, { auth_code: GetRequest().code,corp_id:GetRequest().appid }).then((response) => {
  //         console.log(response)
  //         if(response.data.msg.code==0){
  //           $cookies.set("fanstoken",response.data.result.token )
          
  //           $cookies.set("fansusername",response.data.result.userInfo.realname )
  //           $cookies.set("fanscorpId",response.data.result.userInfo.corpId )
  //           $cookies.set("fanscorpname",response.data.result.userInfo.corpName )
  //           $cookies.set("fanscorpphone",response.data.result.userInfo.phone )
  //           router.push({path:'/navhome'})
       
            // loginusername.value = $cookies.get("fansusername")
  //           logincompname.value=$cookies.get("fanscorpname")
  //         }else{
  //           ElMessage.error(response.data.message)
  //           router.push({ path: '/login' })
  //         }
  //       })
  //     }
      
  //   } else {
  //     if(newValue!='/'){
  //       console.log('--==--')
  //       router.push({ path: '/login' })
  //     }
  //   }
  // }else{
  //   //赋值头像昵称
  //   loginusername.value = $cookies.get("fansusername")
  //   logincompname.value = $cookies.get("fanscorpname")
  // }

  //判断当前是不是登录页面，如果是登录页面，清除样式
  if (newValue == '/login') {
    console.log('清除样式')
    islogin.value = true
  } else {
    islogin.value = false
    newauth().then((response)=>{
        if (response.data.msg.code == 0) {
             console.log('用户信息')
             console.log(response.data)
             console.log('oldValue===')
             console.log(oldValue)
             loginusername.value = response.data.data.username
             loginrole.value = response.data.data.role

            //判断当前路由是否有权限
            if(oldValue){
              console.log('oldValue--:'+oldValue)
              let hasPermission = false
              let accessibleRoute = null
              
              // 先检查当前路由是否有权限
              for(var x = 0;x<navitemlist.data.length;x++){
                if(navitemlist.data[x].path==newValue.split('/')[2]){
                  console.log(navitemlist.data[x].meta.role)
                  if(navitemlist.data[x].meta.role.indexOf(loginrole.value)!=-1){
                    hasPermission = true
                    break
                  }
                }
              }
              
              // 如果当前路由没有权限，查找第一个有权限的路由
              if(!hasPermission){
                for(var x = 0;x<navitemlist.data.length;x++){
                  if(navitemlist.data[x].meta.role.indexOf(loginrole.value)!=-1){
                    accessibleRoute = navitemlist.data[x]
                    break
                  }
                }
                
                // 如果找到有权限的路由，跳转到该路由
                if(accessibleRoute){
                  // ElMessage({
                  //   message: '您没有权限访问当前页面，将跳转到您有权限的页面',
                  //   type: 'warning',
                  // })
                  router.push({ path: '/' + newValue.split('/')[1]+'/' +accessibleRoute.path })
                } else {
                  // 当前一级菜单下没有有权限的页面，遍历其他一级菜单查找
                  for(var z = 0;z<navonelist.data.length;z++){
                    var onelist = navonelist.data[z]
                    // 只查找可见且当前角色有权限的一级菜单
                    if(!onelist.meta.show || onelist.meta.role.indexOf(loginrole.value)==-1){
                      continue
                    }
                    // 在该一级菜单下查找第一个有权限的二级菜单
                    if(onelist.children){
                      for(var y = 0;y<onelist.children.length;y++){
                        if(onelist.children[y].meta.show && onelist.children[y].meta.role.indexOf(loginrole.value)!=-1){
                          accessibleRoute = { path: onelist.path + '/' + onelist.children[y].path }
                          break
                        }
                      }
                      if(accessibleRoute) break
                    }
                  }

                  if(accessibleRoute){
                    // ElMessage({
                    //   message: '您没有权限访问当前页面，将跳转到您有权限的页面',
                    //   type: 'warning',
                    // })
                    router.push({ path: accessibleRoute.path })
                  } else {
                    // 如果没有任何有权限的页面，退出登录
                    ElMessage({
                      message: '您没有权限访问任何页面，将退出登录',
                      type: 'error',
                    })
                    logout()
                  }
                }
              }
            }

        }
    })


  }
}, { immediate: true })


//点击退出登录
const setmine = (e) => {
  if (e == 'logout') {
    return logout()
  }
  if(e == 'mine'){
    //个人信息
    router.push({ path: '/navmine/mine' })
  }
}

</script>

<style >
* {
  box-sizing: border-box;
  text-decoration: none;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
  background-color: #F7F8FC;
  color: #1E293B;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", Roboto, Helvetica, Arial, sans-serif;
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
}

/* 主题色（同步 Element Plus 组件，!important 防止被 element-plus 自带主题覆盖） */
:root {
  --el-color-primary: #4F46E5 !important;
  --el-color-primary-light-3: #7C6CF2 !important;
  --el-color-primary-light-5: #A5B4FC !important;
  --el-color-primary-light-7: #C7D2FE !important;
  --el-color-primary-light-8: #DDD6FE !important;
  --el-color-primary-light-9: #EEF2FF !important;
  --el-color-primary-dark-2: #4338CA !important;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 8px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}
::-webkit-scrollbar-track {
  background: transparent;
}

/* ---------- 顶部一级菜单 ---------- */
.t_top_nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 16px;
  height: 60px;
  padding: 0 22px;
  background: rgba(255, 255, 255, .98);
  border-bottom: 1px solid #E8ECF3;
}

.t_top_logo {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 200px;
  flex-shrink: 0;
  font-size: 19px;
  font-weight: 900;
  letter-spacing: .5px;
  color: #1E293B;
}
.t_top_logo img {
  height: 36px;
  width: auto;
  flex-shrink: 0;
}
.t_top_comp {
  font-size: 13px;
  font-weight: 600;
  color: #94A3B8;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.t_nav_headlist {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 4px;
}
.t_nav_headlist .t_nav_headitem {
  display: flex;
  align-items: center;
  height: 60px;
}
.t_nav_headlist a {
  position: relative;
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #64748B;
  transition: color .15s, background .15s;
}
.t_nav_headlist a:hover {
  color: #1E293B;
  background: #F8FAFC;
}
.t_nav_headlist .router-link-active {
  color: #4F46E5;
}
.t_nav_headlist .router-link-active::after {
  content: "";
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: -2px;
  height: 3px;
  border-radius: 3px;
  background: linear-gradient(90deg, #4F46E5, #7C3AED);
}

.t_myinfobox {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.t_enter_shop {
  background: linear-gradient(90deg, #4F46E5, #7C3AED);
  color: white;
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity .15s;
}
.t_enter_shop:hover {
  opacity: .9;
}
.t_workbench {
  font-size: 14px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  transition: color .15s, background .15s;
}
.t_workbench:hover {
  color: #4F46E5;
  background: #F8FAFC;
}
.t_icon_bell {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid #E8ECF3;
  color: #64748B;
  cursor: pointer;
  transition: color .15s, border-color .15s;
}
.t_icon_bell:hover {
  color: #4F46E5;
  border-color: #C7D2FE;
}
.t_my_msg {
  display: flex;
  align-items: center;
}

.example-showcase .el-dropdown-link {
  cursor: pointer;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px 4px 4px;
  border-radius: 10px;
  transition: background .15s;
}
.example-showcase .el-dropdown-link:hover {
  background: #F8FAFC;
}
.t_avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4F46E5, #7C3AED);
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}
.t_username {
  font-size: 14px;
  font-weight: 600;
}

/* ---------- 页面布局 ---------- */
.t_pagebody {
  display: flex;
  padding-top: 60px;
  min-height: 100vh;
  background-color: #F7F8FC;
}

/* ---------- 左侧二级目录 ---------- */
.t_navslidebox {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 200px;
  z-index: 20;
  background: #ffffff;
  border-right: 1px solid #E8ECF3;
  overflow-y: auto;
  overflow-x: hidden;
}
.t_sidebar_title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #64748B;
  padding: 18px 20px 8px;
}
.t_nav_itemlist {
  padding: 0 12px 20px;
}
.t_nav_item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  margin: 2px 0;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14.5px;
  font-weight: 600;
  color: #64748B;
  transition: background .15s, color .15s;
}
.t_nav_item:hover {
  background: #F1F3F9;
  color: #1E293B;
}
.t_nav_item img,
.t_nav_item svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  opacity: .7;
}
.t_nav_itemlist .router-link-active {
  background: linear-gradient(90deg, rgba(79,70,229,.10), rgba(124,58,237,.05));
  color: #4F46E5;
  font-weight: 700;
  box-shadow: inset 3px 0 0 #4F46E5;
}
.t_nav_itemlist .router-link-active img,
.t_nav_itemlist .router-link-active svg {
  opacity: 1;
}

/* ---------- 主内容区 ---------- */
.t_content_box {
  flex: 1;
  margin-left: 200px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
}
.t_con_content {
  flex: 1;
  height: 0;
  overflow: auto;
  padding: 16px 20px 56px;
}
.t_footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 15;
  font-size: 13px;
  line-height: 36px;
  color: #94A3B8;
  text-align: center;
  background: #F7F8FC;
}
.t_footer a {
  color: #94A3B8;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

/* common css */
.t_content_view {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
  padding: 20px;
  color: #1E293B;
}

.t_search_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.t_search_select {
  display: flex;
  background-color: #F1F3F9;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 15px;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
}
.t_cz_box {
  display: flex;
  justify-content: space-around;
}
.t_add_title {
  color: #1E293B;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 15px;
}
.t_blue_line {
  width: 3px;
  height: 14px;
  background-color: #4F46E5;
  margin-right: 8px;
}
.t_title_box_f {
  display: flex;
  align-items: center;
}
.t_con_box_f {
  display: flex;
  margin-top: 35px;
}
.t_con_title_f {
  width: 150px;
  text-align: right;
  font-size: 15px;
  line-height: 40px;
  box-sizing: border-box;
  padding-right: 10px;
}
.t_headimg {
  width: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
.t_line_blue {
  margin: 0 16px;
  color: #E8ECF3;
}
.t_nav_item_lei {
  background-color: rgba(79, 70, 229, .1);
}
.t_badge {
  font-size: 17px;
}
</style>
